export default {
  BASE_URL: "https://adminapi.groomwell.io",          // live
  // BASE_URL: "https://devadminapi.groomwell.io",          // development
  // BASE_URL: "https://localhost:44349",          // local  
}